import { z } from "zod";
import { JoinPathSchema } from "./JoinPath";

export const ExportColumnOptionSchema = z.object({
  column: z.string(),
  dataType: z.string(),
});

export const ExportJoinColumnOptionSchema = z.object({
  column: z.string(),
  dataType: z.string(),
});

export const ExportJoinOptionSchema = z.object({
  table: z.string(),
  path: z.array(JoinPathSchema).min(1),
  columns: z.array(ExportJoinColumnOptionSchema),
});

export const ExportDefinitionOptionsSchema = z.object({
  columns: z.array(ExportColumnOptionSchema),
  joins: z.array(ExportJoinOptionSchema),
});

export type ExportColumnOption = z.infer<typeof ExportColumnOptionSchema>;
export type ExportJoinColumnOption = z.infer<typeof ExportJoinColumnOptionSchema>;
export type ExportJoinOption = z.infer<typeof ExportJoinOptionSchema>;
export type ExportDefinitionOptions = z.infer<typeof ExportDefinitionOptionsSchema>;